import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class DialogNotificationService {
    private ngbModalRef: NgbModalRef;
    private messageKey: string;
    private messageParams: any;

    constructor(
        private modalService: NgbModal,
        private router: Router,

    ) {
        this.ngbModalRef = null;
    }

    getMessageKey() {
        return this.messageKey;
    }

    getMessageParams() {
        return this.messageParams;
    }

    open(component: Component, messageKey: string, stringParams?: string): Promise<NgbModalRef> {
        this.messageKey = messageKey;
        if (stringParams) {
            try {
                this.messageParams = JSON.parse(stringParams);
            } catch (err) {
                this.messageParams = null;
                console.error(err);
            }
        } else {
            this.messageParams = null;
        }

        return new Promise<NgbModalRef>((resolve, reject) => {
            const isOpen = this.ngbModalRef !== null;
            if (isOpen) {
                resolve(this.ngbModalRef);
            }

            // setTimeout used as a workaround for getting ExpressionChangedAfterItHasBeenCheckedError
            setTimeout(() => {
                this.ngbModalRef = this.DialogNotificationModalRef(component);
                resolve(this.ngbModalRef);
            }, 0);
        });
    }

    DialogNotificationModalRef(component: Component): NgbModalRef {
        const modalRef = this.modalService.open(component, {
            size: 'lg',
            backdrop: true,
            windowClass: 'notification-dialog',
        });

        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { notification: null }}], { replaceUrl: true });
            this.ngbModalRef = null;
        }, (reason) => {
            this.router.navigate([{ outlets: { notification: null }}], { replaceUrl: true });
            this.ngbModalRef = null;
        });

        return modalRef;
    }
}
